import Axios from 'axios';

export const baseURL = 'https://api.ifmcs.com:8816';
export const openURL = 'https://api.ifmcs.com';
// export const baseURL = 'http://192.168.20.32:8815';

// 测试环境
//export const baseURL = 'https://test-api.h1dt.com:8818';
const axios = Axios.create({
	baseURL,
	timeout: 20000 // 请求超时 20s
});
// 前置拦截器（发起请求之前的拦截）
axios.interceptors.request.use(
	(response) => {
		response.headers['open_client'] = '$2a$10$ScatIa5GwuDe8ntVwSZRG.DuyeClz3R.Vv7UxWQb5BRPLf0bQK2g6';
		return response;
	},
	(error) => {
		return Promise.reject(error);
	}
);
// 后置拦截器（获取到响应时的拦截）
axios.interceptors.response.use(
	(response) => {
		/**
		 * 根据实际情况来对 response 和 error 做处理
		 */
		return response;
	},
	(error) => {
		if (error.response && error.response.data) {
			const code = error.response.status;
			const msg = error.response.data.message;
			console.error(`[Axios Error]`, error.response);
		} else {
            console.log('error...', error);
		}
		return Promise.reject(error);
	}
);
// 职责链设计模式
// 每个功能模块仅负责自己的功能
// 完整流程：缓存模块 =》 防止重复提交模块 =》 请求模块 =》 请求处理模块
const myRequest = (function(){
	const cache = {};
	let hasReq = [];
	// { data:{}, go:false, type:'catch }
	let promise = Promise.resolve();
	return function(config){
		// console.log('config...', config);

		let url = config.url;
		function cache(result = { go:true }){
			console.log(result);
			if ( !result.go ) {
				return Promise.resolve(result);
			}
			if ( cache[url] ){
				return Promise.resolve({ go:false, type:'then', data:cache[url] })
			} else {
				// 跳转至下一个模块
				return Promise.resolve({ go:true, type:'then',  })
			}
		}
		function noRepeat(result = { go:true }){
			console.log('repeat...');
			if ( !result.go ){
				return Promise.resolve(result);
			}
			if ( hasReq.indexOf(url) !== -1 ) {
				return Promise.reject({ msg:'请求已经提交', go:false, type:'catch' });
			} else {
				hasReq.push(url);
				return Promise.resolve({ go:true, type:'then' });
			}
		}
		
		async function realRequest(result = { go:true }){
			if ( !result.go ){ 
				return Promise.resolve(result);
			}
			let resData = await axios({ ...config })
			console.log('request...');
			return Promise.resolve({ go:true, type:'then', data:resData });
		}
		function handleRequest(result = { go:true }){
			if ( !result.go ){
				return Promise.resolve(result);
			}
			if ( result.type === 'catch'){
				return Promise.reject(result.data)
			}
			hasReq = hasReq.filter(item=>{
				if ( item !== url ) {
					return item;
				}
			})
			cache[url] = result.data;
			return Promise.resolve(result.data);
		}
		let _handleArr = [cache, noRepeat, realRequest, handleRequest];
		while( _handleArr.length > 0 ){
			promise = promise.then(_handleArr.shift())
		}
		return promise;
		
	}
})();
function delay(ms){
	return new Promise((resolve, reject)=>{
		setTimeout(()=>{
			resolve();
		}, ms)
	})
}
// export default myRequest;
export default axios;
